import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === "/") {
       window.scrollTo({top: 0,behavior: 'smooth',});
    } else if(pathname==='/login')
      {window.scrollTo({ top: 0, behavior: 'smooth',});
    } else if(pathname==='/profail'){
     window.scrollTo({top: 0,behavior: 'smooth',});
    }else if(pathname==='/contact'){
        window.scrollTo({top: 0,behavior: 'smooth',});
    }
    
    else {
      // For inner pages
      window.scrollTo({
        top: 400,
        behavior: 'smooth',
      });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
